import * as yup from 'yup';

export const upnidSchema = yup.object().shape({
  access_token: yup
    .string()
    .required('Este campo é obrigatório.')
    .min(2, 'Informe uma credencial válida')
    .max(200, 'Informe uma credencial válida'),
});
